function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Icon_awesome-hard-hat",
  "data-name": "Icon awesome-hard-hat",
  transform: "translate(1.5 1.5)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Icon_awesome-hard-hat-2",
  "data-name": "Icon awesome-hard-hat",
  d: "M37.615,22.054a15.046,15.046,0,0,0-9.34-13.919l-3.2,6.4V5.754A1.254,1.254,0,0,0,23.823,4.5H16.3a1.254,1.254,0,0,0-1.254,1.254v8.777l-3.2-6.4a15.046,15.046,0,0,0-9.34,13.919v5.015H37.615Zm1.254,7.523H1.254A1.254,1.254,0,0,0,0,30.831v2.508a1.254,1.254,0,0,0,1.254,1.254H38.869a1.254,1.254,0,0,0,1.254-1.254V30.831A1.254,1.254,0,0,0,38.869,29.577Z",
  transform: "translate(0 -4.5)",
  fill: "none",
  stroke: "#fff",
  strokeWidth: 3
}));

function SvgModalWorker(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 43.123,
    height: 33.092,
    viewBox: "0 0 43.123 33.092",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgModalWorker);
export default __webpack_public_path__ + "static/media/modalWorker.c09224fed483b7bf2ff00a7a5527d025.svg";
export { ForwardRef as ReactComponent };